import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BankIdService } from '@app/authentication/shared/services/bankid.service';
import { GuiParams } from '@app/shared/store/gui-params/gui-params-facade.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AppGtmService } from '@app/shared/services/gtm.service';

export enum BankidType {
  // Values have to reflect corresponding language group names in langauage json files.
  register = 'signUp',
  login = 'login',
}

@Component({
  selector: 'app-bankid-button',
  templateUrl: './bankid-button.component.html',
  styleUrls: ['./bankid-button.component.scss'],
  standalone: false,
})
export class BankidButtonComponent implements OnInit, OnDestroy {
  @Input() type: BankidType = BankidType.login;

  lang = 'cs';
  isRegistrationBlocked = false;

  protected readonly BankidType = BankidType;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private bankIdService: BankIdService,
    private gtmService: AppGtmService,
    private guiParams: GuiParams,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.lang = this.translateService.currentLang;
    this.translateService.onLangChange.pipe(takeUntil(this.unsubscribe$)).subscribe((data) => (this.lang = data.lang));
    this.guiParams.guiParams$.pipe(takeUntil(this.unsubscribe$)).subscribe((guiParams) => {
      this.isRegistrationBlocked = guiParams.bankidRegistrationBlocked;
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getBankIdRedirect(): string {
    return this.bankIdService.getBankIdRedirect();
  }

  clickBankIdButton() {
    if (this.isRegistrationBlocked && this.type === BankidType.register) {
      return;
    }

    if (this.type === BankidType.register) {
      this.gtmService.pushTag({
        event: 'registration_start',
        method: 'bankid',
      });
    }

    if (typeof window !== 'undefined') {
      window.location.href = this.getBankIdRedirect();
    }
  }
}
